import { PublicationCode } from '@/scopes/common/domain/constants/publication-codes'
import { CatalogueType } from '@/scopes/common/domain/enums/CatalogueType'
import { useFeatureFlag } from '@/scopes/common/infrastructure/feature-flags'
import {
  FilterComponentMap,
  getFilterComponentsConfigurationsByCatalogueType,
} from '@/scopes/search/search/domain/policies/filters'

export function DynamicFilters({
  catalogue,
  publicationCode,
}: {
  catalogue: CatalogueType
  publicationCode?: PublicationCode
}) {
  const isAirlineFilterEnabled = useFeatureFlag('BAHAMAS_ENABLE_AIRLINE_FILTER')
  const filterComponentsConfigurations = getFilterComponentsConfigurationsByCatalogueType(
    catalogue,
    publicationCode,
    { isAirlineFilterEnabled },
  )

  return filterComponentsConfigurations.map((filterComponentsConfiguration) => {
    const FilterComponentName = filterComponentsConfiguration.filterComponent

    const FilterComponent = FilterComponentMap[FilterComponentName]
    return <FilterComponent key={FilterComponentName} defaultOpen={filterComponentsConfiguration.defaultOpen} />
  })
}
